/**
 * 홈(`/`) 판정 — SSR·하이드레이션 양쪽에서 «같은 답» 을 내는 유일한 함수 (C 레인 · 2026-09-26).
 *
 * ⛔ `usePathname() === '/'` 를 서버에서 렌더되는 클라이언트 컴포넌트에 쓰지 마라.
 *    실측(프리뷰 97f2c386 홈 HTML): ISR 로 구운 `/` 의 RSC 초기 상태가 `"c":["","index"]` —
 *    서버 렌더 중 usePathname() 은 «/index» 를 돌려준다. 브라우저 하이드레이션에서는 «/» 다.
 *    그래서 ClientShell 의 `isHome` 이 서버=false / 클라이언트=true 로 갈려
 *    (NoticeBanner 자리·FooterTalkBanner 가 서버에만 렌더) 홈 전체가 React #418 로 다시 그려졌다
 *    (MutationObserver 실측: head meta 부터 통째 교체 · SSR↔클라이언트 트리 첫 차이 = footer 의 공유방 링크).
 * ⚠️ ssr:false 컴포넌트(Navigation·InstallBanner 등)는 서버에서 렌더되지 않아 이 문제가 없다.
 */
export function isHomePath(pathname: string | null | undefined): boolean {
  return pathname === '/' || pathname === '/index';
}
